module.exports = __webpack_public_path__ + "media/images/partner-5-1d21aaac2a42a187d2950150957d7e69.png";